var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DesktopHeader',{class:{ 'hide-mobile-slider': !_vm.getFilteredOffers.length }}),(_vm.getFilteredOffers.length)?_c('MobileHeader'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }